export enum StagesDiagnosesEnum {
  MEDICAL_HISTORY = 1,
  OASES = 2,
  SSRS = 3,
  SSI4 = 4,
  LIVE_SESSIONS = 5,
  SSI4_Evaluation = 6,
  Live_Sessions_Evalutation = 7,
  Generating_Report = 8,
  Supervisor_Approval = 9,
  Booking = 10,
  Done = 11,
  Pre_Treatment = 12,
  Treatment_Session_1= 13,
  Treatment_Session_2= 14,
  Treatment_Session_3= 15,
  Treatment_Session_4= 16,
  Treatment_Session_5= 17,
  Treatment_Session_6= 18,
  Treatment_Session_7= 19,
  Treatment_Session_8= 20,
  Treatment_Session_9= 21,
  Treatment_Session_10= 22,
  Treatment_Session_11= 23,
  Treatment_Session_12= 24,
  Treatment_Session_13= 25,
  Treatment_Session_14= 26,
  Treatment_Session_15= 27,

  Treatment_Session_16= 28,
  Treatment_Session_17= 29,
  Treatment_Session_18= 30,
  Treatment_Session_19= 31,
  Treatment_Session_20= 32,
  Treatment_Session_21= 33,
  Treatment_Session_22= 34,
  Treatment_Session_23= 35,
  Treatment_Session_24= 36,
  Treatment_Session_25= 37,
  Treatment_Session_26= 38,
  Treatment_Session_27= 39,
  Treatment_Session_28= 40,
  Treatment_Session_29= 41,
  Treatment_Session_30= 42

}
